import { render } from "./CompanySettings.vue?vue&type=template&id=a1e2bb90&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"

import "./CompanySettings.vue?vue&type=style&index=0&id=a1e2bb90&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/views/company-settings.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FCompanySettings.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/company-settings.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FCompanySettings.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e2bb90"]])

export default __exports__